<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      :permanent="screenIsWideEnough"
      :temporary="!screenIsWideEnough"
      :absolute="!screenIsWideEnough"
      floating
      :class="{ 'grey lighten-2': screenIsWideEnough, white: !screenIsWideEnough }"
    >
      <template v-slot:prepend>
        <v-toolbar
          :class="{ transparent: !screenIsWideEnough, primary: screenIsWideEnough }"
          @click.native.stop="miniVariant = !miniVariant"
          flat
          :dark="screenIsWideEnough"
        >
          <v-avatar size="40px" style="margin-right: 16px;">
            <img
              src="https://s3-eu-west-1.amazonaws.com/media.alternativebusinessfunding.co.uk/public/logo.png"
              alt=""
            />
          </v-avatar>
          <v-toolbar-title>ABF Platform</v-toolbar-title>
        </v-toolbar>
      </template>

      <template v-slot:append>
        <UserStatus :current-user="CurrentUser" :platform-user="PlatformUser" :user-name="UserName" />
      </template>

      <v-list class="mt-2 overflow-y-auto" nav dense>
        <!--          <v-subheader>CRM</v-subheader>-->
        <v-list-item to="/dashboard" v-if="UIMenuOptions.dashboard" active-class="primary--text">
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;" v-bind="attrs" v-on="on">
                  fad fa-fw fa-columns
                </v-icon>
              </template>
              <span>Dashboard</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-3" v-if="UIMenuOptions.dashboard"></v-divider>

        <v-subheader v-if="UIMenuOptions.customers">Customer Service</v-subheader>

        <v-list-item to="/customers" v-if="UIMenuOptions.customers" active-class="active--link primary--text">
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                  v-bind="attrs"
                  v-on="on"
                  >fad fa-fw fa-users</v-icon
                >
              </template>
              <span>Customers</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Customers</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/referrals" v-if="UIMenuOptions.referrals" active-class="active--link primary--text">
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                  v-bind="attrs"
                  v-on="on"
                  >fad fa-fw fa-people-carry</v-icon
                >
              </template>
              <span>Referrals</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Referrals</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="diallerRoute" v-if="UIMenuOptions.dialler" active-class="active--link primary--text">
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-badge
                  color="error"
                  :content="TodaysCallCount"
                  :value="TodaysCallCount && TodaysCallCount > 0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                  >
                    fad fa-fw fa-phone
                  </v-icon>
                </v-badge>
              </template>
              <span>Dialler</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Dialler</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-3" v-if="UIMenuOptions.customers"></v-divider>

        <v-subheader v-if="UIMenuOptions.customers">Providers &amp; Partners</v-subheader>

        <v-list-item to="/funders" v-if="UIMenuOptions.funders" active-class="active--link primary--text">
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                  v-bind="attrs"
                  v-on="on"
                  >fad fa-fw fa-coins</v-icon
                >
              </template>
              <span v-if="UIMenuOptions.customers">Funders</span>
              <span v-else>Products</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-if="UIMenuOptions.customers">Funders</v-list-item-title>
            <v-list-item-title v-else>Products</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/partners" v-if="UIMenuOptions.partners" active-class="active--link primary--text">
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                  v-bind="attrs"
                  v-on="on"
                  >fad fa-fw fa-handshake</v-icon
                >
              </template>
              <span>Partners</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Partners</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/banks" v-if="UIMenuOptions.banks" active-class="active--link primary--text">
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                  v-bind="attrs"
                  v-on="on"
                  >fad fa-fw fa-university</v-icon
                >
              </template>
              <span>Banks</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Banks</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-3" v-if="UIMenuOptions.customers"></v-divider>

        <v-subheader v-if="UIMenuOptions.billing">Billing</v-subheader>
        <v-list-item to="/bills" v-if="UIMenuOptions.billing" active-class="active--link primary--text">
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                  v-bind="attrs"
                  v-on="on"
                  >fad fa-fw fa-pound-sign</v-icon
                >
              </template>
              <span>Billing</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Billing</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-3" v-if="UIMenuOptions.billing"></v-divider>

        <v-subheader v-if="UIMenuOptions.maintenance">Admin</v-subheader>

        <v-list-group
          v-if="UIMenuOptions.maintenance"
          prepend-icon="fad fa-fw fa-cogs"
          style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
        >
          <template slot="activator">
            <v-list-item-title>Settings</v-list-item-title>
          </template>
          <v-list-item to="/imports" v-if="UIMenuOptions.imports" active-class="active--link primary--text">
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                    v-bind="attrs"
                    v-on="on"
                    >fad fa-fw fa-file-import</v-icon
                  >
                </template>
                <span>Bank Imports</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Bank Imports</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/accounts" v-if="UIMenuOptions.accounts" active-class="active--link primary--text">
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                    v-bind="attrs"
                    v-on="on"
                    >fad fa-fw fa-id-card</v-icon
                  >
                </template>
                <span>Accounts</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Accounts</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/me" v-if="UIMenuOptions.user" active-class="active--link primary--text">
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                    v-bind="attrs"
                    v-on="on"
                    >fad fa-fw fa-user-cog</v-icon
                  >
                </template>
                <span>My Details</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>My Details</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/platforms" v-if="UIMenuOptions.platforms" active-class="active--link primary--text">
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                    v-bind="attrs"
                    v-on="on"
                    >fad fa-fw fa-headset</v-icon
                  >
                </template>
                <span>Platforms</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Platforms</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/brokers" v-if="UIMenuOptions.brokers" active-class="active--link primary--text">
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                    v-bind="attrs"
                    v-on="on"
                    >fad fa-fw fa-user-chart</v-icon
                  >
                </template>
                <span v-if="UserHasRole('Broker')">Account settings</span>
                <span v-else>Brokers</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-if="UserHasRole('Broker')">Account settings</v-list-item-title>
              <v-list-item-title v-else>Brokers</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/questions" v-if="UIMenuOptions.questions" active-class="active--link primary--text">
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                    v-bind="attrs"
                    v-on="on"
                    >fad fa-fw fa-question</v-icon
                  >
                </template>
                <span>Questions</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Questions</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/adverts" v-if="UIMenuOptions.adverts" active-class="active--link primary--text">
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                    v-bind="attrs"
                    v-on="on"
                    >fad fa-fw fa-ad</v-icon
                  >
                </template>
                <span>Adverts</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Adverts</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-if="UIMenuOptions.maintenance"
          prepend-icon="fad fa-fw fa-tasks-alt"
          style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
        >
          <template slot="activator">
            <v-list-item-title>Product Admin</v-list-item-title>
          </template>

          <v-list-item to="/product-types" v-if="UIMenuOptions.accounts" active-class="active--link primary--text">
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                    v-bind="attrs"
                    v-on="on"
                    >fad fa-fw fa-shapes</v-icon
                  >
                </template>
                <span>Product Types</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Product Types</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            to="/product-suitability"
            v-if="UIMenuOptions.accounts"
            active-class="active--link primary--text"
          >
            <v-list-item-icon>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar size="32" tile>
                    <v-icon
                      style="--fa-primary-color: #321A32; --fa-secondary-color: #5C415B;--fa-secondary-opacity: 0.6;"
                      v-bind="attrs"
                      v-on="on"
                      >fad fa-fw fa-balance-scale-left</v-icon
                    >
                  </v-avatar>
                </template>
                <span>Product Suitability</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Product Suitability</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider class="mt-3" v-if="UIMenuOptions.maintenance"></v-divider>

    </v-navigation-drawer>
    <v-snackbar v-model="updateAvailable" bottom light color="info" :timeout="updateTimeout">
      A new version of the ABF Platform has been released.
      <v-btn text color="primary" @click="reload">Update</v-btn>
    </v-snackbar>
    <router-view></router-view>
    <abf-app-notifications />
    <v-progress-circular
      indeterminate
      style="position: absolute;top:10px;right:10px;z-index: 10000"
      color="warning"
      size="42"
      v-if="showSaveSpinner"
    >
      <v-icon small color="warning">fad fa-save</v-icon>
    </v-progress-circular>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AbfAppNotifications from '@/components/Abf/AbfAppNotifications';
import UserStatus from './UserStatus';
import api from '@/api/api';

export default {
  name: 'Platform',
  components: { UserStatus, AbfAppNotifications },
  data: () => ({
    clipped: false,
    show: false,
    miniVariant: true,
    updateAvailable: false,
    updateTimeout: 0,
    updateIntervalId: null,
    items: [
      {
        icon: 'dashboard',
        title: 'Dashboard'
      },
      {
        icon: 'people',
        title: 'Customers'
      }
    ]
  }),
  methods: {
    ...mapActions(['addNotification', 'getDiallerQueues', 'toggleLeftDrawer', 'logout', 'updateUILeftDrawerState']),
    startListeningToForCalls: function() {
      this.getDiallerQueues();
    },
    reload() {
      window.location.reload(true);
    },
    async getLatestPlatformVersion() {
      let res = await api.get('platform-version');
      return res.data.version;
    },
    async checkVersion() {
      const currentVersion = process.env.VUE_APP_PLATFORM_VERSION;
      const latestVersion = await this.getLatestPlatformVersion();
      if (currentVersion !== latestVersion) {
        this.updateAvailable = true;
      }
    }
  },
  computed: {
    ...mapGetters([
      'ActiveHttpRequests',
      'UILeftDrawer',
      'DiallerQueues',
      'PlatformUser',
      'UserHasRole',
      'UIMenuOptions',
      'CurrentUser',
      'UserName',
      'TodaysCallCount',
      'UserId'
    ]),
    showSaveSpinner: function() {
      return this.ActiveHttpRequests > 0;
    },
    diallerRoute: function() {
      return this.DiallerQueues.length > 0 ? `/dialler/${this.DiallerQueues[0].id}` : '/dialler';
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    drawer: {
      get() {
        return this.UILeftDrawer;
      },
      set(state) {
        this.updateUILeftDrawerState(state);
      }
    },
    isMiniVariant: function() {
      return this.screenIsWideEnough && this.miniVariant;
    }
  },
  mounted() {
    this.$store.dispatch('getEnquiryStatusList');
    this.startListeningToForCalls();
    this.checkVersion();
    this.updateIntervalId = setInterval(this.checkVersion, 60 * 5 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.updateIntervalId);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/*.active--link {*/
/*  border-radius: 0 25px 25px 0;*/
/*}*/

/*.theme--light .v-list .v-list-item--link {*/
/*  &.active--link {*/
/*    background: #cebacd;*/
/*    .v-list-item__title {*/
/*      font-weight: bold;*/
/*    }*/
/*  }*/
/*}*/
.theme--light.v-application {
  background: #e0e0e0 !important;
}
.v-navigation-drawer .theme--light.v-list {
  background: inherit;
}
.abf-logo-list {
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-navigation-drawer--temporary,
.v-navigation-drawer--is-mobile {
  z-index: 1000;
}

.v-btn {
  letter-spacing: normal;
}

.calc-height {
  height: calc(100vh - 125px);
  max-height: calc(100vh - 125px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
</style>
